import React from "react";
import ViewAllGrn from "./ViewAllGrn";
import ViewAllGrnOld from "./ViewAllGrnOld";

const ViewAllGrnContainer = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const ViewAllGrnV2 = ConfigDictionary?.ViewAllGrnV2 ?? false;

  return ViewAllGrnV2 ? (
    <ViewAllGrn />
  ) : (
    <ViewAllGrnOld />
  );
};

export default ViewAllGrnContainer;
